import Header from "@/components/Header/Header.vue"

export default {
    name: 'Hours',
    components: {
        Header,
    },
}